import { Pipe, PipeTransform } from '@angular/core';
import { FpValueService } from "../../core/component/pojo/fp-modify-value.service";

/**
 * This pipe modifies a numerical value by formatting it with a prefix, suffix
 * and specifying decimals. Large numbers are formatted with suffix (K, M and B).
 * Negative values are wrapped in parentheses.
 *
 * @param value - The numeric value to be formatted.
 * @param prefix - string value
 * @param suffix - string value
 * @param decimals - The number of decimal places to include in the formatted value.
 * @returns The formatted string representation of the value.
 *
 * @see FpValueService
 */
@Pipe({
  name: 'fpModifyValue',
  standalone: true,
})
export class FpModifyValuePipe implements PipeTransform {

  transform(value: number, prefix = '', suffix = '', decimals = 1): string {
    return FpValueService.modify(value, prefix, suffix, decimals);
  }

}
